import { Button, TextField, Modal } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import "./Question.css";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

const Question = ({
  currQues,
  setCurrQues,
  questions,
  options,
  correct,
  setScore,
  score,
  setQuestions,
  activities,
  setActivities,
  correctQuestions,
  setCorrectQuestions
}) => {
  const [selected, setSelected] = useState();
  const [input, setInput] = useState();
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState();
  const [currentAct, setCurrentAct] = useState([]);
  const [currentCorrectQ, setCurrentCorrectQ] = useState([]);

  const history = useHistory();

  useEffect(() => {
    window.onbeforeunload = function() {
        return true;
    };

    return () => {
        window.onbeforeunload = null;
    };
  }, []);

  const handleSelect = (i) => {
    if (selected === i) return "select";
  };

  const handleCheck = (i) => {
    setSelected(i);
    if (i === correct) {
      setScore(score + 1);
      const question = [...currentCorrectQ];
      question.push(questions[currQues]._id);
      setCurrentCorrectQ(question);
      setCorrectQuestions(currentCorrectQ);
    }
    setError(false);
  };

  const handleUserInput = () => {
    setSelected(input);
    if (input.toLowerCase() === correct.toLowerCase()) {
      setScore(score + 1);
      const question = [...currentCorrectQ];
      question.push(questions[currQues]._id);
      setCurrentCorrectQ(question);
      console.log(question)
      setCorrectQuestions(currentCorrectQ);
    }
    setError(false);
    setInput('');
  };

  const openImageModal = () => {
    setOpen(true);
    setImage((
      <div className="modal">
        <img src={questions[currQues].image_link} alt='' />
      </div>
    ));
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (selected) {
      if (currQues > questions.length - 2) {
        setActivities(currentAct);
        setCorrectQuestions(currentCorrectQ);
        history.push("/result");
      } else if (selected) {
        setCurrQues(currQues + 1);
        setSelected();
      } else setError("Please select an option first");
    }
  }, [selected, setCurrQues, setSelected, setError, currQues, questions, history, setCorrectQuestions, currentCorrectQ, currentAct, setActivities]);  

  useEffect(() => {
    // Set the name of the hidden property and the change event for visibility
    let hidden, visibilityChange; 
    if (typeof document.hidden !== "undefined") {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }

    let eventTriggered = [];

    function handleVisibilityChange() {
      if (document.hidden === true) {
        eventTriggered = [...currentAct];
        eventTriggered.push({
          timestamp: new Date().toISOString(),
          action: 'Changed Window or Tab'
        });
        setCurrentAct(eventTriggered);
      }
    }

    // Warn if the browser doesn't support addEventListener or the Page Visibility API
    if (typeof document.addEventListener === "undefined" || hidden === undefined) {
      console.log("This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
    } else {
      // Handle page visibility change   
      document.addEventListener(visibilityChange, handleVisibilityChange, false);
    }
    const handleEsc = (event) => {
       if (event.keyCode === 18) {
        eventTriggered = [...currentAct];
        eventTriggered.push({
          timestamp: new Date().toISOString(),
          action: 'Pressed Alt Key'
        });
        setCurrentAct(eventTriggered);
       }
       if (event.keyCode === 91) {
        eventTriggered = [...currentAct];
        eventTriggered.push({
          timestamp: new Date().toISOString(),
          action: 'Pressed Windows Key'
        });
        setCurrentAct(eventTriggered);
       }
       if (event.keyCode === 123) {
        eventTriggered = [...currentAct];
        eventTriggered.push({
          timestamp: new Date().toISOString(),
          action: 'Pressed F12 Key'
        });
        setCurrentAct(eventTriggered);
       }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };

  }, [setCurrentAct, currentAct]);


  return (
    <div className="question">
      <h1>Question {currQues + 1} of {questions.length}:</h1>

      <div className="singleQuestion">
        <h2>{questions[currQues].question}</h2>
        { ['multiple choice', 'true or false'].includes(questions[currQues].type.toLowerCase()) &&
          <div className="options">
            {error && <ErrorMessage>{error}</ErrorMessage>}
            {options &&
              options.map((i) => (
                <button
                  className={`singleOption  ${selected && handleSelect(i)}`}
                  key={i}
                  onClick={() => handleCheck(i)}
                  disabled={selected}
                >
                  {i}
                </button>
              ))}
          </div>
        }
        { questions[currQues].type.toLowerCase() === 'identification' &&
          <div className="options">
            {error && <ErrorMessage>{error}</ErrorMessage>}
            {options &&
              <TextField
              style={{ marginBottom: 25 }}
              value={input || ''}
              label="Enter answer"
              variant="outlined"
              onChange={(e) => setInput(e?.target?.value)}
            />
            }
          </div>
        }
        <div className="controls">
          { questions[currQues]?.image_link && <Button
            variant="contained"
            color="secondary"
            size="large"
            style={{ width: 185 }}
            onClick={openImageModal}
          >
            View Image
          </Button>
        }
        { image && 
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            {image}
          </Modal>
        }
        { questions[currQues].type.toLowerCase() === 'identification' &&
          <Button
            variant="contained"
            color="primary"
            disabled={!Boolean(input) && input !== ' '}
            size="large"
            style={{ width: 185 }}
            onClick={(e) => handleUserInput()}
          >
            Next question
          </Button>
        }
        </div>
      </div>
    </div>
  );
};

export default Question;
